import { storageGet, storageSet } from './libs/localStorage';

let basketLs = storageGet('basketItems');
let basketItems = {};

const basketUpdate = new CustomEvent('basketUpdate');

const setBasketItems = () => {
  basketLs = storageGet('basketItems');
  basketItems = basketLs;
};
const setBasketButtons = () => {
  const entityAdd = [];
  const entityLink = [];
  const entityFromSet = {};
  const basketItemsKeys = Object.keys(basketItems || {});

  basketItemsKeys.forEach((el) => {
    if (!basketItems[el].FROM_SET) {
      entityAdd.push(`basket-add-${basketItems[el].PRODUCT_ID}`);
      entityLink.push(`basket-link-${basketItems[el].PRODUCT_ID}`);
    } else {
      if (!Array.isArray(entityFromSet[basketItems[el].PRODUCT_ID])) {
        entityFromSet[basketItems[el].PRODUCT_ID] = [];
      }
      entityFromSet[basketItems[el].PRODUCT_ID].push(`setitem-${basketItems[el].PRODUCT_ID}`);
    }
  });
  const btnAdd = document.querySelectorAll('[data-basket-entity^="basket-add-"]');
  btnAdd.forEach((el) => {
    if (entityAdd.includes(el.dataset.basketEntity)) {
      el.style.display = 'none';
    } else if (el.attributes['data-entity']?.value === 'quantity-block'
              || el.querySelector('[data-entity="quantity-block"]')) {
      el.style.display = 'flex';
    } else {
      el.style.display = 'block';
    }
  });
  const btnLink = document.querySelectorAll('[data-basket-entity^="basket-link-"]');
  btnLink.forEach((el) => {
    if (entityLink.includes(el.dataset.basketEntity)) {
      el.style.display = 'block';
      if (el.querySelector('[data-entity="quantity-block"]')) {
        el.style.display = 'flex';
      }
    } else {
      el.style.display = 'none';
    }
  });

  const itemsInSet = document.querySelectorAll('[data-id^="setitem-"]');
  itemsInSet.forEach((el) => {
    el.classList.remove('already_in_basket');
  });
  const setKeys = Object.keys(entityFromSet);
  setKeys.forEach((key) => {
    const setProducts = document.querySelectorAll('[data-set-product-id]');
    setProducts.forEach((el) => {
      const itemNode = el.querySelector(`[data-id="setitem-${key}"]`);
      if (itemNode) {
        itemNode.classList.add('already_in_basket');
      }
    });
  });
};
const getBasketItems = async () => {
  const response = await fetch('/local/ajax/basket/getItems.php', {
    method: 'POST',
  });
  if (response.ok) {
    const result = await response.json();
    storageSet({ key: 'basketItems', value: result });
    storageSet({ key: 'lastTimeBasketUpdate', value: Date.now() });
    basketLs = result;
    basketItems = basketLs;
    setBasketButtons();
    window.dispatchEvent(basketUpdate);
  }
};
window.getBasketItems = getBasketItems;

if (basketLs !== null) {
  basketItems = basketLs;
} else {
  getBasketItems();
}
setBasketButtons();

window.basketUpdate = () => {
  setBasketItems();
  setBasketButtons();
  window.dispatchEvent(basketUpdate);
};

window.addEventListener('phpSessIdUpdate', () => {
  window.isSessionIdUpdate = true;

  getBasketItems();

  setTimeout(() => {
    window.isSessionIdUpdate = false;
  }, 1000);
});

window.setBasketButtons = setBasketButtons;
